import SharedLayouts from "../Layouts/SharedLayout";
import * as rsuite from 'rsuite';
import { HiEye, HiOutlineTrash } from "react-icons/hi";
import {
  useReactTable,
  getCoreRowModel,
} from "@tanstack/react-table";
import useToaster from 'rsuite/useToaster';
import React, { useEffect, useState } from "react";
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as General from '../General/General';
import { useNavigate } from "react-router-dom";
import CrudPageHeader from "../components/CrudPageHeader";
import DataTable from "../components/DataTable";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";

const ContactMessages = () => {
    //#region const
    const navigate = useNavigate();
    const toaster = useToaster();
    const [Messages, setMessages] = useState([]);
    const [SelectedMessage, setSelectedMessage] = useState(null);
    const [ShowViewModal, setShowViewModal] = useState(false);
    const [ShowDeleteModal, setShowDeleteModal] = useState(false);
    const [MessageId, setMessageId] = useState(General.GuidEmpty());
    const [ErrorMsg, setErrorMsg] = useState("");
    //#endregion
    //#region method
    const GetMessages = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/contact/getAll',
            method: "get",
            headers: General.AuthHeader(),
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setMessages(result.data)
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }

    const ViewMessage = (row) => {
        setSelectedMessage(row);
        setShowViewModal(true);
        if (!row.IsRead) {
            MarkRead(row.Id, true, false);
        }
    }

    const MarkRead = (id, isRead, refresh = true) => {
        var RequestOption = {
            url: General.ApiRoot() + '/contact/markRead/' + id,
            method: "post",
            data: { IsRead: isRead },
            headers: {
                'Content-Type': 'application/json',
                ...General.AuthHeader(),
            },
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    if (refresh) {
                        toaster.push(General.ShowMessage('success', 'عملیات با موفقیت انجام شد'), 'topCenter');
                    }
                    GetMessages();
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در انجام عملیات';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }

    const Delete = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/contact/delete/' + MessageId,
            method: "delete",
            headers: General.AuthHeader(),
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setErrorMsg("");
                    toaster.push(General.ShowMessage('success', 'عملیات حذف با موفقیت انجام شد'), 'topCenter');
                    GetMessages();
                    setMessageId(General.GuidEmpty());
                    setShowDeleteModal(false);
                    setShowViewModal(false);
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در انجام عملیات';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    //#endregion

    const columns = [
        {
            id: "isRead",
            header: () => <div className="text-right">وضعیت</div>,
            cell: ({ row }) => <div className="">{row.original.IsRead ? "خوانده شده" : <strong>خوانده نشده</strong>}</div>,
        },
        {
            id: "name",
            header: () => <div className="text-right">نام</div>,
            cell: ({ row }) => <div className="">{row.original.Name}</div>,
        },
        {
            id: "email",
            header: () => <div className="text-right">ایمیل</div>,
            cell: ({ row }) => <div className="">{row.original.Email}</div>,
        },
        {
            id: "phone",
            header: () => <div className="text-right">تلفن</div>,
            cell: ({ row }) => <div className="">{row.original.Phone}</div>,
        },
        {
            id: "message",
            header: () => <div className="text-right">پیام</div>,
            cell: ({ row }) => <div className="truncate max-w-xs">{row.original.Message}</div>,
        },
        {
            id: "location",
            header: () => <div className="text-right">موقعیت</div>,
            cell: ({ row }) => (
                <div className="">
                    {[row.original.City, row.original.Country].filter(Boolean).join("، ") || "نامشخص"}
                </div>
            ),
        },
        {
            id: "createdAt",
            header: () => <div className="text-right">تاریخ</div>,
            cell: ({ row }) => <div className="">{new Date(row.original.CreatedAt).toLocaleString('fa-IR')}</div>,
        },
        {
            id: "actions",
            header: () => <div className="text-center me-8">عملیات</div>,
            cell: ({ row }) => (
                <rsuite.Row className="w-[100%] h-[100%]">
                    <rsuite.Col xs={12} className="flex justify-end">
                        <rsuite.Button appearance="primary" onClick={() => ViewMessage(row.original)}>
                            <HiEye />
                        </rsuite.Button>
                    </rsuite.Col>
                    <rsuite.Col xs={12}>
                        <rsuite.Button color="red" appearance="primary" onClick={() => (setMessageId(row.original.Id), setShowDeleteModal(true))}>
                            <HiOutlineTrash />
                        </rsuite.Button>
                    </rsuite.Col>
                </rsuite.Row>
            ),
        },
    ];

    const table = useReactTable({
        data: Messages,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    useEffect(() => {
        if (!General.isLoggedIn()) {
            navigate('/');
        }
        else {
            GetMessages();
        }
    }, []);

    return (
        <SharedLayouts>
            <div className="bg-white h-screen w-full px-2">
                {ErrorMsg && (
                    <rsuite.Message type="error" showIcon closable onClose={() => setErrorMsg("")} className="mb-2">
                        {ErrorMsg}
                    </rsuite.Message>
                )}
                <CrudPageHeader title="پیام‌های تماس با ما" />
                <DataTable table={table} />
            </div>

            <rsuite.Modal open={ShowViewModal} onClose={() => setShowViewModal(false)}>
                <rsuite.Modal.Header>
                    <p className="sm:text-2xl">جزئیات پیام</p>
                </rsuite.Modal.Header>
                <rsuite.Modal.Body className="px-2">
                    {SelectedMessage && (
                        <>
                            <p className="mb-2"><strong>نام: </strong>{SelectedMessage.Name}</p>
                            <p className="mb-2"><strong>ایمیل: </strong>{SelectedMessage.Email}</p>
                            <p className="mb-2"><strong>تلفن: </strong>{SelectedMessage.Phone}</p>
                            <p className="mb-2">
                                <strong>موقعیت: </strong>
                                {[SelectedMessage.City, SelectedMessage.Country].filter(Boolean).join("، ") || "نامشخص"}
                                {SelectedMessage.IPAddress ? ` (${SelectedMessage.IPAddress})` : ""}
                            </p>
                            <p className="mb-2"><strong>تاریخ: </strong>{new Date(SelectedMessage.CreatedAt).toLocaleString('fa-IR')}</p>
                            <rsuite.Divider />
                            <p className="whitespace-pre-wrap">{SelectedMessage.Message}</p>
                        </>
                    )}
                </rsuite.Modal.Body>
                <rsuite.Modal.Footer>
                    <rsuite.Button
                        onClick={() => (setMessageId(SelectedMessage.Id), setShowDeleteModal(true))}
                        appearance="primary"
                        color="red"
                        startIcon={<HiOutlineTrash className="me-1" />}
                    >
                        حذف
                    </rsuite.Button>
                    <rsuite.Button onClick={() => setShowViewModal(false)} appearance="subtle">
                        بستن
                    </rsuite.Button>
                </rsuite.Modal.Footer>
            </rsuite.Modal>

            <ConfirmDeleteModal
                open={ShowDeleteModal}
                message="آیا از حذف این پیام مطمئن هستید؟در صورت حذف قادر به بازیابی اطلاعات نخواهید بود."
                onConfirm={Delete}
                onCancel={() => (setShowDeleteModal(false), setMessageId(General.GuidEmpty()))}
            />
        </SharedLayouts>
    )
}
export default ContactMessages;
